import { Box, Stack, Text } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import { getArchiveData } from '../services/Archive.js';
import { useEffect, useMemo, useState } from 'react';
import GeneralArchive from './Archive/GeneralArchive.js';
import Section1 from './Archive/Section1/Section1.js';
import MyTabsNested from '../components/MyTabsNested.js';
import { useSelector } from 'react-redux';
import MyAccordionNested from '../components/MyAccordionNested.js';
import Section2 from './Archive/Section2/Section2.js';
import Section3 from './Archive/Section3/Section3.js';
import Section4 from './Archive/Section4/Section4.js';
import Section5 from './Archive/Section5/Section5.js';
import Section6 from './Archive/Section6/Section6.js';
import ResearchCategories from './Archive/ResearchCategories/ResearchCategories.js';
import Keywords from './Archive/Keywords/Keywords.js';
import Dimensions from './Archive/Dimensions/Dimensions.js';
import Highlights from './Libraries/Highlights/Highlights.js';

const EditArchiveRecord = () => {

  const { alias, archiveAlias } = useParams();
  const isTabDisabled = alias ? false : true;
  const [archiveTitle, setArchiveTitle] = useState();
  // const location = useLocation();
  // const navigate = useNavigate();
  const mainArchiveAlias = archiveAlias ? archiveAlias : alias;
  const previewEnabled = useSelector(state => state.preview.isEnabled);


  const tabs = useMemo(() => [
    {
      id: "general", title: "General", Component: GeneralArchive, subTabs: [
        { id: "quadrant-1", title: "Quadrant-1", Component: Section1 },
        { id: "quadrant-2", title: "Quadrant-2", Component: Section2, isDisabled: isTabDisabled },
        { id: "quadrant-3", title: "Quadrant-3", Component: Section3, isDisabled: isTabDisabled },
        { id: "quadrant-4", title: "Quadrant-4", Component: Section4, isDisabled: isTabDisabled },
        { id: "quadrant-5", title: "Quadrant-5", Component: Section5, isDisabled: isTabDisabled },
        { id: "quadrant-6", title: "Quadrant-6", Component: Section6, isDisabled: isTabDisabled },
        { id: "researchCategories", title: "Research Categories", Component: ResearchCategories, isDisabled: isTabDisabled },
        { id: "keywords", title: "Keywords", Component: Keywords, isDisabled: isTabDisabled },
        { id: "dimensions", title: "Dimensions", Component: Dimensions, isDisabled: isTabDisabled },
        { id: "highlights", title: "Highlights", Component: Highlights, isDisabled: isTabDisabled },
      ]
    }
  ], [isTabDisabled]);

  useEffect(() => {
    const getBasicData = async () => {
      try {
        if (mainArchiveAlias) {
          const result = await getArchiveData(mainArchiveAlias, 'title');

          if (result) {
            const citation = result?.data?.[0]?.bibliographic_citation;
            const caption = result?.data?.[0]?.bibliographic_caption;
            setArchiveTitle(citation || caption);
          }
        }
      } catch (error) {
        console.error('Error fetching film data:', error);
      }
    };

    getBasicData();
  }, [mainArchiveAlias]);

  // Determine if we're in research category context
  const isResearchCategory = !!archiveAlias;

  // Define base path based on context
  const basePath = isResearchCategory
    ? `/research-categories/${archiveAlias}/research-centre/archive/${mainArchiveAlias}`
    : `/archive/${archiveAlias}`;

  // Redirect to default tab if no tab is specified

  // Below code is need to fix for preview mode

  // useEffect(() => {
  //   const pathParts = location.pathname.split('/');

  //   if (!location.pathname.includes('/create')) {
  //     // Determine the expected tab position based on URL structure
  //     const tabPosition = isResearchCategory ? 5 : 2; // 0-indexed position of tab in path parts

  //     // Check if path already has tab and subtab
  //     const hasTab = pathParts?.length > tabPosition;
  //     const hasSubtab = pathParts?.length > tabPosition + 1;

  //     if (!hasTab || !hasSubtab) {
  //       // Redirect to default tab/subtab
  //       const defaultPath = `${basePath}/${tabs[0].id}/${tabs[0].subTabs[0].id}`;
  //       navigate(defaultPath, { replace: true });
  //     }
  //   }
  // }, [location.pathname, alias, navigate, tabs, isResearchCategory, basePath]);


  return (
    <Stack px="1rem" pb={'1rem'} width={"100%"}>
      <Box>
        <Text fontSize={"18px"} pt={2} fontWeight={"600"}>{archiveTitle}</Text>
      </Box>
      {previewEnabled ? (
        <MyAccordionNested
          orientation="vertical"
          list={tabs}
          urlBasePath={basePath}
          includeALias={false} // Don't add alias again since it's in basePath
          tabSegmentPosition={isResearchCategory ? 5 : 2}
          subTabSegmentPosition={isResearchCategory ? 6 : 3}
        />
      ) : (
        <MyTabsNested
          orientation="vertical"
          list={tabs}
          urlBasePath={isResearchCategory
            ? `/research-categories/${archiveAlias}/research-centre/archive/${mainArchiveAlias}`
            : `/archive/${mainArchiveAlias}`}
          includeALias={false}
          tabSegmentPosition={isResearchCategory ? 5 : 2}
          subTabSegmentPosition={isResearchCategory ? 6 : 3}
        />
      )}
    </Stack>
  );
};

export default EditArchiveRecord;